import {NgModule} from '@angular/core';
import {CatchLinksDirective} from './catch-links';

@NgModule({
  declarations: [CatchLinksDirective],
  imports: [],
  exports: [CatchLinksDirective]
})
export class DirectivesModule {
}



// WEBPACK FOOTER //
// ./src/directives/directives.module.ts